import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckSquare, LucideAngularModule, Square } from 'lucide-angular';
import { ItemEducacionalColorService } from '@core/context/services/item-educacional-color.service';
import { ComponenteOption } from './context-selector-modal.model';

/**
 * Lista de componentes curriculares (checkbox múltiplo ou radio de seleção
 * única) do context-selector-modal. Recebe o MESMO array de referência que o
 * pai usa (`componentes`) e muta os objetos em `selected` diretamente — igual
 * ao comportamento de antes da extração, sem precisar de @Output pra cada toggle.
 */
@Component({
  selector: 'app-componentes-curriculares-select',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './componentes-curriculares-select.component.html'
})
export class ComponentesCurricularesSelectComponent {
  @Input() componentes: ComponenteOption[] = [];
  @Input() selecaoUnica = false;
  @Input() enabled = true;

  readonly CheckSquareIcon = CheckSquare;
  readonly SquareIcon = Square;

  constructor(private colorService: ItemEducacionalColorService) {}

  toggleComponente(componente: ComponenteOption): void {
    if (this.selecaoUnica) {
      // Turma de atividade ou EJA modular: seleção única (radio button)
      const wasSelected = componente.selected;
      this.componentes.forEach(c => c.selected = false);
      componente.selected = !wasSelected;
    } else {
      componente.selected = !componente.selected;
    }
  }

  todosComponentesSelecionados(): boolean {
    return this.componentes.length > 0 && this.componentes.every(c => c.selected);
  }

  toggleTodosComponentes(): void {
    if (this.selecaoUnica) {
      return;
    }
    const todosSelec = this.todosComponentesSelecionados();
    this.componentes.forEach(c => c.selected = !todosSelec);
  }

  getComponenteColor(index: number): string {
    return this.colorService.getColorByIndex(index);
  }
}
